<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="ResolDeltaSolMxPlus_1d00"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ResolDeltaSolMxPlus_1d00 from '@/device-products/ResolDeltaSolMxPlus_1d00.vue';
import ResolEM from '@/device-products/ResolEM.vue';
import DdsSensor from '@/device-products/DdsSensor.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
          {
            id: 'Regler zu Modul 1',
            from: { deviceId: 0, uart: 0},
            to: { deviceId: 3, uart: 0},
          }, {
            id: 'Modul 1 zu Modul 2',
            from: { deviceId: 3, uart: 0},
            to: { deviceId: 4, uart: 0},
          }, {
            id: 'Modul 2 zu Modul ',
            from: { deviceId: 4, uart: 0},
            to: { deviceId: 5, uart: 0},
          }, {
            id: 'Modul 3 zu Modul ',
            from: { deviceId: 5, uart: 0},
            to: { deviceId: 6, uart: 0},
          }, {
            id: 'Modul 4 zu Modul ',
            from: { deviceId: 6, uart: 0},
            to: { deviceId: 7, uart: 0},
          }, {
            id: 'Regler zu RCS 1',
            from: { deviceId: 0, uart: 0},
            to: { deviceId: 8, uart: 0},
          }
        ],
      },
      {
        label: 'DDS', connections: [
          {
            id: 'Regler zu DDS 1',
            from: { deviceId: 0, uart: 1},
            to: { deviceId: 1, uart: 0},
          },
          {
            id: 'Regler zu DDS 2',
            from: { deviceId: 0, uart: 1},
            to: { deviceId: 2, uart: 0},
          }
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: ResolDeltaSolMxPlus_1d00, deviceLabel: null },
      { id: 1, component: DdsSensor, deviceLabel: 'DDS 1', deviceColor: 'green', props: {
        defaultSensorType: 'RPD',
        defaultValues: [ // FIXME(robin) defautl values anhand der conversion geht nicht, sieghe RCS (3 x raw)
          { conversion: 'rawTemperature', value: 22.0 },
          { conversion: 'rawPressure', value: 2.0 },
        ],
      }},
      { id: 2, component: DdsSensor, deviceLabel: 'DDS 2', deviceColor: 'green darken-2', props: {
        defaultSensorType: 'VFD2_40F',
        defaultValues: [
          { conversion: 'rawTemperature', value: 22.0 },
          { conversion: 'rawFlow', value: 4.0 },
        ],
      }},
      { id: 3, component: ResolEM, deviceLabel: 'Modul 1', deviceColor: 'blue lighten-4', props: {
        vbusAddress: 0x6651,
      }},
      { id: 4, component: ResolEM, deviceLabel: 'Modul 2', deviceColor: 'blue lighten-2', props: {
        vbusAddress: 0x6652,
      }},
      { id: 5, component: ResolEM, deviceLabel: 'Modul 3', deviceColor: 'blue', props: {
        vbusAddress: 0x6653,
      }},
      { id: 6, component: ResolEM, deviceLabel: 'Modul 4', deviceColor: 'blue darken-2', props: {
        vbusAddress: 0x6654,
      }},
      { id: 7, component: ResolEM, deviceLabel: 'Modul 5', deviceColor: 'blue darken-4', props: {
        vbusAddress: 0x6655,
      }},
      { id: 8, component: DdsSensor, deviceLabel: 'RCS 1', deviceColor: 'green darken-2', props: {
        defaultSubAddress: '1',
        defaultSensorType: 'RCS',
        allowedSensorTypes: ['RCS'],
        defaultValues: [
          { conversion: 'rawTemperature', value: 22.0 },
          { conversion: 'rawHumidity', value: 20.0 },
          { conversion: 'rawPercent', value: 50.0 },
          { fieldIndex: 3, value: 0 },
          { conversion: 'rawPressure', value: 1.0 },
          { conversion: 'rawIaq', value: 100.0 },
          { fieldIndex: 6, value: 0 },
          { fieldIndex: 7, value: 0 },
        ],
      }},
    ],
  }),
};
</script>

<style>

</style>
